import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  href?: string;
  target?: string;
  rel?: string;
  onLinkClick?: () => void;
}
const classes = 'inline-flex items-center justify-center px-8 py-4 text-lg font-extrabold text-white bg-cta hover:bg-cta-hover rounded-full shadow-[0_12px_28px_-12px_rgba(22,163,74,0.75)] transition-colors duration-200 text-center tracking-wide';
export function Button({
  children,
  className = '',
  href,
  target,
  rel,
  onLinkClick,
  ...props
}: ButtonProps) {
  if (href) {
    return <motion.a href={href} target={target} rel={rel ?? (target === '_blank' ? 'noopener noreferrer' : undefined)} onClick={onLinkClick} className={`${classes} ${className}`} whileHover={{
      scale: 1.03
    }} whileTap={{
      scale: 0.97
    }} data-id="element-61" data-mp="288cqz1oc15n4">
        {children}
      </motion.a>;
  }
  return <motion.button className={`${classes} ${className}`} whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.97
  }} {...props} data-id="element-62" data-mp="d171edo6hv5l">
      {children}
    </motion.button>;
}